import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, MenuItem, Select, TextField, Typography } from "@mui/material"
import useWidth from "../../../hooks/useWidth"
import { useEffect, useState } from "react";
import useRolesManagement from "../../../hooks/useRolesManagement"
import { ThreeDots } from 'react-loader-spinner';
import usePackageManagement from "../../../hooks/usePackageManagement";


const CreatePackageDialog = (props) => {

    const { openCreatePackage, handleClose,getPackageSummary } = props;

    const breakpoints = useWidth();
    const { createPackage, creatingPackage, createdPackage } = usePackageManagement();

    const [package_name, setPackageName] = useState('');
    const [package_description, setPackageDescription] = useState('');

    const handleTextFieldChange = (e, name) => {
        if (name == "package_name") {
            setPackageName(e.target.value);

        } else if (name == "package_description") {
            setPackageDescription(e.target.value);

        }
    }


    const handleCreatePackage = () => {

        let payload = {
            package_name : package_name,
            description : package_description,
        }

        createPackage(payload);

    }

    useEffect(() => {

        if(createdPackage){
            handleClose()
            // window.location.reload();
            getPackageSummary();
        }

    },[createdPackage])
 
   
    return (
        <Dialog open={openCreatePackage} onClose={handleClose} PaperProps={{ style: { boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 5 } }}>
            <DialogTitle>
                Create Package
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: (breakpoints == "xs" || breakpoints == "sm") ? {} : 6, paddingTop: 4 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ alignSelf: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold' }}>Package Name :</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            autoComplete="off"
                            value={package_name}
                            onChange={(e) => handleTextFieldChange(e, "package_name")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ alignSelf: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold' }}>Package Description :</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            autoComplete="off"
                            value={package_description}
                            onChange={(e) => handleTextFieldChange(e, "package_description")}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: breakpoints == 'xs' || breakpoints == 'sm' ? 3 : 6, paddingTop: 0, paddingBottom: 3 }}>
                <Button onClick={handleClose} sx={{ color: "black", textTransform: "none", fontSize: 14 }} >
                    Cancel
                </Button>

                <Button variant="contained" sx={{ backgroundColor: "#0178f2", borderRadius: 1, textTransform: "none", fontSize: 14, '&:hover': { backgroundColor: "#0178f2", color: "white" } }}
                   onClick={() => handleCreatePackage() }
                   startIcon={creatingPackage && 
                        <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} /> 
                    }
                >
                    {creatingPackage ? "Creating" : "Create"} 
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CreatePackageDialog